import { render, staticRenderFns } from "./BronchopneumoniaScoreComponent.vue?vue&type=template&id=7cd71b76&"
import script from "./BronchopneumoniaScoreComponent.vue?vue&type=script&lang=ts&"
export * from "./BronchopneumoniaScoreComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports